import React from 'react';
import { LinksListInput } from './LinksListInput';

interface LinksFieldProps {
  label: string;
  required?: boolean;
  value: Array<{ label: string; url: string }>;
  onChange: (_value: Array<{ label: string; url: string }>) => void;
  placeholder?: string;
  error?: string;
}

export const LinksField: React.FC<LinksFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  error
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <LinksListInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </>
  );
};
